import React, { Fragment } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { AuthTypeEnum, CourseTypeEnum } from "../../../enums";
import AdminGuard from "./AdminGuard";
import LoggedInGuard from "./LoggedInGuard";
import SuspenseGuard from "./SuspenseGuard";
import { MainPage } from "../../../pages/mainPage/mainPage";
import UserInfoProvider from "../../../context/userContext";
import CourseProvider from "../../../context/courseContext";
import { MainEgePage } from "../../../pages/mainEgePage/mainEgePage";
import { LoginPage } from "../../../pages/loginPage/loginPage";
import { PrintCourse } from "../../../pages/print/printCourse";
import NotFound from "../../../pages/notFoundPage/notFoundPage";
import { LearningPage } from "../../../pages/learningPage/learningPage";
import { AnswersPage } from "../../../pages/answersPage/answersPage";
import { HomeworkPage } from "../../../pages/homeworkPage/homeworkPage";
import { ExamPage } from "../../../pages/examPage/examPage";
import { ThemePage } from "../../../pages/themePage/themePage";
import { CourseTaskPage } from "../../../pages/courseTaskPage/courseTaskPage";
import { ScrollToTop, ScrollToBottom } from "../../../shared/ScrollToTop";
import { LogoutForm } from "../../../widgets/loginForm";
import { Report83Page } from "../../../pages/report83/report83";
const LkPage = React.lazy(() => import("../../../pages/lkPage/lkPage"));
const CourseEditPage = React.lazy(
  () => import("../../../pages/editPage/courseEditPage"),
);
const CourseCreatePage = React.lazy(
  () => import("../../../pages/editPage/courseCreatePage"),
);
const TaskCreatePage = React.lazy(
  () => import("../../../pages/editPage/taskCreatePage"),
);
const TaskEditPage = React.lazy(
  () => import("../../../pages/editPage/taskEditPage"),
);
import TaskViewPage from "../../../pages/editPage/taskViewPage";
import RolesGuard from "./RolesGuard";
import { OneChat } from "../../../pages/chat/oneChatPage";
import { OneChatSettings } from "../../../pages/chat/oneChatSettingsPage";
import { Land1Page } from "../../../pages/land1Page";
import OneTaskPage from "../../../pages/OneTaskPage";
const TeacherUsersPage = React.lazy(
  () => import("../../../pages/lkPage/teacherUsersPage"),
);
const GenList = React.lazy(
  () => import("../../../pages/generatorPage/genList"),
);
const ShowReportPage = React.lazy(
  () => import("../../../pages/reportsPage/showReportPage"),
);
const LkForTeacherPageWithId = React.lazy(
  () => import("../../../pages/lkForTeacherPage/lkForTeacherPageWithId"),
);
const LkForTeacherPage = React.lazy(
  () => import("../../../pages/lkForTeacherPage/lkForTeacherPage"),
);

const GeneratorPage = React.lazy(
  () => import("../../../pages/generatorPage/generatorPage"),
);

const FMLSecretsArticlePage = React.lazy(
  () => import("../../../pages/articles/fMLSecretsArticlePage"),
);
const FeaturesOfMinimathArticlePage = React.lazy(
  () => import("../../../pages/articles/featuresOfMinimathArticlePage"),
);
const TeachingPage = React.lazy(
  () => import("../../../pages/teachingPage/teachingPage"),
);
const ArticlesPage = React.lazy(
  () => import("../../../pages/articlesPage/articlesPage"),
);
const AchievementsPage = React.lazy(
  () => import("../../../pages/achievementsPage/achievementsPage"),
);
const Results2022Page = React.lazy(
  () => import("../../../pages/achievements/results2022Page"),
);
const Results2021Page = React.lazy(
  () => import("../../../pages/achievements/results2021Page"),
);
const Results2020Page = React.lazy(
  () => import("../../../pages/achievements/results2020Page"),
);
const BusinessOfferPage = React.lazy(
  () => import("../../../pages/achievements/businessOfferPage"),
);
const ChangesToLessonsPage = React.lazy(
  () => import("../../../pages/achievements/changesToLessonsPage"),
);
const CongratulationsAntonPage = React.lazy(
  () => import("../../../pages/achievements/congratulationsAntonPage"),
);
const PreparationModePage = React.lazy(
  () => import("../../../pages/achievements/preparationModePage"),
);
const SummerLessonsPage = React.lazy(
  () => import("../../../pages/achievements/summerLessonsPage"),
);
const StudentsCongratulationsPage = React.lazy(
  () => import("../../../pages/achievements/studentsCongratulationsPage"),
);
const IndividualLessonsPage = React.lazy(
  () => import("../../../pages/achievements/individualLessonsPage"),
);
const AnswersToLessonsPage = React.lazy(
  () => import("../../../pages/achievements/answersToLessonsPage"),
);
const FinalOlympiadStagePage = React.lazy(
  () => import("../../../pages/articles/finalOlympiadStagePage"),
);
const SolvingProblemArrivedPage = React.lazy(
  () => import("../../../pages/articles/solvingProblemArrivedPage"),
);
const FML239BestSchoolPage = React.lazy(
  () => import("../../../pages/articles/fML239BestSchoolPage"),
);
const HowAndWhyMathPage = React.lazy(
  () => import("../../../pages/articles/howAndWhyMathPage"),
);

const FeedbackPage = React.lazy(
  () => import("../../../pages/feedbackPage/feedbackPage"),
);
const OurTeamPage = React.lazy(
  () => import("../../../pages/ourTeamPage/ourTeamPage"),
);
const ParentsPage = React.lazy(
  () => import("../../../pages/parentsPage/parentsPage"),
);
const AgreementOfAccessionPage = React.lazy(
  () => import("../../../pages/agreementOfAccessionPage"),
);
const RulesPage = React.lazy(() => import("../../../pages/rulesPage"));
const PricesPage = React.lazy(() => import("../../../pages/pricesPage"));
const RulesShortPage = React.lazy(
  () => import("../../../pages/rulesShortPage"),
);
const PrivacyPage = React.lazy(
  () => import("../../../pages/privacyPage/privacyPage"),
);
const FefelovaPage = React.lazy(
  () => import("../../../pages/fefelovaPage/fefelovaPage"),
);
const ProfilePage = React.lazy(
  () => import("../../../pages/profilePage/profilePage"),
);
const ResetPasswordPage = React.lazy(
  () => import("../../../pages/resetPasswordPage/resetPasswordPage"),
);
const ForgotPasswordPage = React.lazy(
  () => import("../../../pages/forgotPasswordPage/forgotPasswordPage"),
);
const ConfirmEmailPage = React.lazy(
  () => import("../../../pages/confirmEmailPage/confirmEmailPage"),
);
const AllUsers = React.lazy(() => import("../../../pages/allUsers"));
const EditUser = React.lazy(() => import("../../../pages/editUser"));
const ReportsPage = React.lazy(
  () => import("../../../pages/reportsPage/reportsPage"),
);
const SchedulePage = React.lazy(
  () => import("../../../pages/schedulePage/schedulePage"),
);
const SelfPayment = React.lazy(() => import("../../../pages/selfPaymentPage"));

function AppRoutes() {
  return (
    <Fragment>
      <Routes>
        <Route
          path={"/"}
          element={
            <SuspenseGuard>
              <MainPage />
            </SuspenseGuard>
          }
        />
        <Route
          path={"/land1"}
          element={
            <CourseProvider>
              <SuspenseGuard>
                <Land1Page />
              </SuspenseGuard>
            </CourseProvider>
          }
        />
        <Route
          path={"/print/course/:id"}
          element={
            <CourseProvider>
              <SuspenseGuard>
                <LoggedInGuard>
                  <PrintCourse />
                </LoggedInGuard>
              </SuspenseGuard>
            </CourseProvider>
          }
        />
        <Route
          path={"/ege"}
          element={
            <SuspenseGuard>
              <MainEgePage />
            </SuspenseGuard>
          }
        />
        <Route
          path="/login"
          element={
            <SuspenseGuard>
              <LoginPage type={AuthTypeEnum.LOGIN} />
            </SuspenseGuard>
          }
        />
        <Route path="/logout" element={<LogoutForm />} />
        <Route
          path="/register"
          element={
            <SuspenseGuard>
              <LoginPage type={AuthTypeEnum.REGISTER} />
            </SuspenseGuard>
          }
        />
        <Route
          path="/fefelova"
          element={
            <SuspenseGuard>
              <FefelovaPage />
            </SuspenseGuard>
          }
        />
        <Route
          path="/theme/:id"
          element={
            <CourseProvider>
              <SuspenseGuard>
                <ScrollToTop />
                <CourseTaskPage courseType={CourseTypeEnum.THEME} />
              </SuspenseGuard>
            </CourseProvider>
          }
        />
        <Route
          path="/exam/:id"
          element={
            <CourseProvider>
              <SuspenseGuard>
                <ScrollToTop />
                <CourseTaskPage courseType={CourseTypeEnum.EXAM} />
              </SuspenseGuard>
            </CourseProvider>
          }
        />
        <Route
          path="/course/:id"
          element={
            <CourseProvider>
              <SuspenseGuard>
                <ScrollToTop />
                <CourseTaskPage courseType={CourseTypeEnum.COURSE} />
              </SuspenseGuard>
            </CourseProvider>
          }
        />
        <Route
          path="/admin/course/:id"
          element={
            <CourseProvider>
              <SuspenseGuard>
                <AdminGuard>
                  <CourseTaskPage courseType={CourseTypeEnum.COURSE} />
                </AdminGuard>
              </SuspenseGuard>
            </CourseProvider>
          }
        />
        <Route
          path="/exam"
          element={
            <CourseProvider>
              <SuspenseGuard>
                <ExamPage />
              </SuspenseGuard>
            </CourseProvider>
          }
        />
        <Route
          path="/theme"
          element={
            <CourseProvider>
              <SuspenseGuard>
                <ThemePage />
              </SuspenseGuard>
            </CourseProvider>
          }
        />
        <Route
          path="/confirm-email"
          element={
            <SuspenseGuard>
              <ConfirmEmailPage />
            </SuspenseGuard>
          }
        />
        <Route
          path="/confirm-email/:token"
          element={
            <SuspenseGuard>
              <ConfirmEmailPage />
            </SuspenseGuard>
          }
        />
        {/* vvvvvvvvvvvvvvvvvvvvvvvvvvvvvv */}
        <Route
          path="/articles/sekrety-fml-239-ili-pochemu-litsej-pobezhdaet-moskvichej-na-olimpiadakh"
          element={
            <SuspenseGuard>
              <ScrollToTop />
              <FMLSecretsArticlePage />
            </SuspenseGuard>
          }
        />
        <Route
          path="/articles/osobennosti-trenazhera-minimath239"
          element={
            <SuspenseGuard>
              <ScrollToTop />
              <FeaturesOfMinimathArticlePage />
            </SuspenseGuard>
          }
        />
        <Route
          path="/articles/fml-239-lider-vsosch-2022"
          element={
            <SuspenseGuard>
              <ScrollToTop />
              <FinalOlympiadStagePage />
            </SuspenseGuard>
          }
        />
        <Route
          path="/articles/the-problem-is-about-those-who-arrived-earlier-and-those-who-are-late"
          element={
            <SuspenseGuard>
              <ScrollToTop />
              <SolvingProblemArrivedPage />
            </SuspenseGuard>
          }
        />
        <Route
          path="/articles/fml-239-luchshaya-shkola-rossii-mnenie-glavnogo-trenera-sbornoj-rossii-po-matematike-kirilla-sukhova"
          element={
            <SuspenseGuard>
              <ScrollToTop />
              <FML239BestSchoolPage />
            </SuspenseGuard>
          }
        />
        <Route
          path="/articles/sergej-rukshin-kak-i-zachem-uchitsya-matematike-kak-uchit-devochek"
          element={
            <SuspenseGuard>
              <ScrollToTop />
              <HowAndWhyMathPage />
            </SuspenseGuard>
          }
        />
        <Route
          path="/teaching-lessons"
          element={
            <SuspenseGuard>
              <TeachingPage />
            </SuspenseGuard>
          }
        />
        <Route
          path="/articles"
          element={
            <SuspenseGuard>
              <ScrollToTop />
              <ArticlesPage />
            </SuspenseGuard>
          }
        />
        {/* ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^ */}
        <Route
          path="/feedback"
          element={
            <SuspenseGuard>
              <ScrollToTop />
              <FeedbackPage />
            </SuspenseGuard>
          }
        />
        <Route
          path="/our-team"
          element={
            <SuspenseGuard>
              <OurTeamPage />
            </SuspenseGuard>
          }
        />
        <Route
          path="/parents"
          element={
            <SuspenseGuard>
              <ParentsPage />
            </SuspenseGuard>
          }
        />
        <Route
          path="/theagreementofaccession"
          element={
            <SuspenseGuard>
              <AgreementOfAccessionPage />
            </SuspenseGuard>
          }
        />
        <Route
          path="/rules"
          element={
            <SuspenseGuard>
              <RulesPage />
            </SuspenseGuard>
          }
        />
        <Route
          path="/rules-short"
          element={
            <SuspenseGuard>
              <RulesShortPage />
            </SuspenseGuard>
          }
        />
        <Route
          path="/prices"
          element={
            <SuspenseGuard>
              <PricesPage />
            </SuspenseGuard>
          }
        />
        {/* vvvvvvvvvvvvvvvvvvvvvvvvvvvvvv */}
        <Route
          path="/achievements"
          element={
            <SuspenseGuard>
              <ScrollToTop />
              <AchievementsPage />
            </SuspenseGuard>
          }
        />
        <Route
          path="/achievements/2022-results"
          element={
            <SuspenseGuard>
              <Results2022Page />
            </SuspenseGuard>
          }
        />
        <Route
          path="/achievements/2021-results"
          element={
            <SuspenseGuard>
              <Results2021Page />
            </SuspenseGuard>
          }
        />
        <Route
          path="/achievements/2020-results"
          element={
            <SuspenseGuard>
              <Results2020Page />
            </SuspenseGuard>
          }
        />
        <Route
          path="/achievements/business-offer-5-grade"
          element={
            <SuspenseGuard>
              <BusinessOfferPage />
            </SuspenseGuard>
          }
        />
        <Route
          path="/achievements/changes-to-individual-lessons"
          element={
            <SuspenseGuard>
              <ChangesToLessonsPage />
            </SuspenseGuard>
          }
        />
        <Route
          path="/achievements/congratulations-anton-a"
          element={
            <SuspenseGuard>
              <CongratulationsAntonPage />
            </SuspenseGuard>
          }
        />
        <Route
          path="/achievements/preparation-mode"
          element={
            <SuspenseGuard>
              <PreparationModePage />
            </SuspenseGuard>
          }
        />
        <Route
          path="/achievements/summer-lessons"
          element={
            <SuspenseGuard>
              <SummerLessonsPage />
            </SuspenseGuard>
          }
        />
        <Route
          path="/achievements/congratulations-to-all-stundents"
          element={
            <SuspenseGuard>
              <StudentsCongratulationsPage />
            </SuspenseGuard>
          }
        />
        <Route
          path="/achievements/individual-lessons"
          element={
            <SuspenseGuard>
              <IndividualLessonsPage />
            </SuspenseGuard>
          }
        />
        <Route
          path="/achievements/answers-to-lessons-conditions"
          element={
            <SuspenseGuard>
              <AnswersToLessonsPage />
            </SuspenseGuard>
          }
        />
        {/* ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^ */}
        <Route
          path="/admin/task/edit/:id"
          element={
            <SuspenseGuard>
              <RolesGuard roles={["A", "D"]}>
                <TaskEditPage />
              </RolesGuard>
            </SuspenseGuard>
          }
        />
        <Route
          path="/task/:id"
          element={
            <CourseProvider>
              <SuspenseGuard>
                <OneTaskPage />
              </SuspenseGuard>
            </CourseProvider>
          }
        />

        {/* <Route
          path="/course/:id"
          element={
            <CourseProvider>
              <SuspenseGuard>
                <ScrollToTop />
                <CourseTaskPage courseType={CourseTypeEnum.COURSE} />
              </SuspenseGuard>
            </CourseProvider>
          }
        /> */}

        <Route
          path="/task/view/:id"
          element={
            <SuspenseGuard>
              <RolesGuard roles={["A", "D", "T", "S"]}>
                <TaskViewPage />
              </RolesGuard>
            </SuspenseGuard>
          }
        />
        <Route
          path="/admin/allusers"
          element={
            <SuspenseGuard>
              <AdminGuard>
                <AllUsers />
              </AdminGuard>
            </SuspenseGuard>
          }
        />
        <Route
          path="/admin/edituser/:id"
          element={
            <SuspenseGuard>
              <AdminGuard>
                <EditUser />
              </AdminGuard>
            </SuspenseGuard>
          }
        />
        <Route
          path="/admin/generators"
          element={
            <SuspenseGuard>
              <AdminGuard>
                <GenList />
              </AdminGuard>
            </SuspenseGuard>
          }
        />
        <Route
          path="/admin/generator/:id"
          element={
            <SuspenseGuard>
              <AdminGuard>
                <GeneratorPage />
              </AdminGuard>
            </SuspenseGuard>
          }
        />
        <Route
          path="/admin/reports"
          element={
            <SuspenseGuard>
              <RolesGuard roles={["A", "T", "D", "S"]}>
                <ReportsPage />
              </RolesGuard>
            </SuspenseGuard>
          }
        />
        <Route
          path="/admin/showreport"
          element={
            <SuspenseGuard>
              <RolesGuard roles={["A", "T", "D", "S"]}>
                <ShowReportPage />
              </RolesGuard>
            </SuspenseGuard>
          }
        />
        <Route
          path="/admin/create-task"
          element={
            <SuspenseGuard>
              <AdminGuard>
                <TaskCreatePage />
              </AdminGuard>
            </SuspenseGuard>
          }
        />
        <Route
          path="/admin/create-course"
          element={
            <SuspenseGuard>
              <RolesGuard roles={["A", "D"]}>
                <CourseCreatePage />
              </RolesGuard>
            </SuspenseGuard>
          }
        />
        <Route
          path="/admin/course/edit/:id"
          element={
            <SuspenseGuard>
              <RolesGuard roles={["A", "D"]}>
                <CourseEditPage />
              </RolesGuard>
            </SuspenseGuard>
          }
        />
        <Route
          path="/lk-for-teacher"
          element={
            <SuspenseGuard>
              <RolesGuard roles={["A", "T"]}>
                <LkForTeacherPage />
              </RolesGuard>
            </SuspenseGuard>
          }
        />
        <Route
          path="/lk-for-teacher/:id"
          element={
            <SuspenseGuard>
              <RolesGuard roles={["A"]}>
                <LkForTeacherPageWithId />
              </RolesGuard>
            </SuspenseGuard>
          }
        />
        <Route
          path="/account"
          element={
            <UserInfoProvider>
              <SuspenseGuard>
                <LoggedInGuard>
                  <ProfilePage />
                </LoggedInGuard>
              </SuspenseGuard>
            </UserInfoProvider>
          }
        />
        <Route
          path="/lk"
          element={
            <UserInfoProvider>
              <SuspenseGuard>
                <LoggedInGuard>
                  <LkPage />
                </LoggedInGuard>
              </SuspenseGuard>
            </UserInfoProvider>
          }
        />
        <Route
          path="/lk/teacher-users"
          element={
            <UserInfoProvider>
              <SuspenseGuard>
                <LoggedInGuard>
                  <TeacherUsersPage />
                </LoggedInGuard>
              </SuspenseGuard>
            </UserInfoProvider>
          }
        />
        <Route
          path="/pay"
          element={
            <UserInfoProvider>
              <SuspenseGuard>
                <LoggedInGuard>
                  <SelfPayment />
                </LoggedInGuard>
              </SuspenseGuard>
            </UserInfoProvider>
          }
        />
        <Route
          path="/chat/:id"
          element={
            <UserInfoProvider>
              <SuspenseGuard>
                <LoggedInGuard>
                  <ScrollToBottom />
                  <OneChat />
                </LoggedInGuard>
              </SuspenseGuard>
            </UserInfoProvider>
          }
        />
        <Route
          path="/chat/:id/settings"
          element={
            <UserInfoProvider>
              <SuspenseGuard>
                <LoggedInGuard>
                  <OneChatSettings />
                </LoggedInGuard>
              </SuspenseGuard>
            </UserInfoProvider>
          }
        />
        <Route
          path="/learning"
          element={
            <SuspenseGuard>
              <LoggedInGuard>
                <LearningPage />
              </LoggedInGuard>
            </SuspenseGuard>
          }
        />
        <Route
          path="/learning/:id"
          element={
            <SuspenseGuard>
              <LoggedInGuard>
                <LearningPage />
              </LoggedInGuard>
            </SuspenseGuard>
          }
        />
        <Route
          path="/schedule/:id"
          element={
            <SuspenseGuard>
              <RolesGuard roles={["A", "T"]}>
                <SchedulePage />
              </RolesGuard>
            </SuspenseGuard>
          }
        />
        <Route
          path="/answers"
          element={
            <SuspenseGuard>
              <AnswersPage />
            </SuspenseGuard>
          }
        />
        <Route
          path="/answers/:id"
          element={
            <SuspenseGuard>
              <LoggedInGuard>
                <AnswersPage />
              </LoggedInGuard>
            </SuspenseGuard>
          }
        />
        <Route
          path="/homework/:id"
          element={
            <SuspenseGuard>
              <LoggedInGuard>
                <HomeworkPage />
              </LoggedInGuard>
            </SuspenseGuard>
          }
        />
        <Route
          path="/report83/:id"
          element={
            <SuspenseGuard>
              <LoggedInGuard>
                <Report83Page />
              </LoggedInGuard>
            </SuspenseGuard>
          }
        />
        <Route
          path="/privacy"
          element={
            <SuspenseGuard>
              <PrivacyPage />
            </SuspenseGuard>
          }
        />
        <Route
          path="/reset/:token"
          element={
            <SuspenseGuard>
              <ResetPasswordPage />
            </SuspenseGuard>
          }
        />
        <Route
          path="/forgot-password"
          element={
            <SuspenseGuard>
              <ForgotPasswordPage />
            </SuspenseGuard>
          }
        />
        <Route path="/404" element={<NotFound />} />
        <Route path="*" element={<Navigate to={"/404"} />} />
      </Routes>
    </Fragment>
  );
}

export default AppRoutes;
